import React from 'react'
import { useTranslation } from 'react-i18next'

import SegmentedSelector from './SegmentedSelector'
import { PERIODS } from '../constants'
import { ProductAnalyticsPeriod } from '../types'

type PeriodSelectorProps = {
  value: ProductAnalyticsPeriod
  onChange: (period: ProductAnalyticsPeriod) => void
}

const PeriodSelector: React.FC<PeriodSelectorProps> = ({ value, onChange }) => {
  const { t } = useTranslation()

  return (
    <SegmentedSelector
      value={value}
      options={PERIODS}
      onChange={onChange}
      getOptionLabel={period => t(`stats.product_analytics.period.${period}`)}
      ariaLabel={t('stats.product_analytics.period.label')}
    />
  )
}

export default PeriodSelector
